import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core'

export default class Sliders {
    bindArrows(splide, prev, next) {
        document.querySelector(prev)?.addEventListener('click', () => splide.go('<'))
        document.querySelector(next)?.addEventListener('click', () => splide.go('>'))
    }

    hero() {
        const el = document.querySelector('[data-hero-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'loop',
            gap: 0,
            autoplay: true,
            interval: 5000,
            speed: 800,
            arrows: false,
            pagination: false,
            pauseOnHover: false,
        }).mount()

        this.bindArrows(splide, '[data-hero-prev]', '[data-hero-next]')
    }

    tech() {
        const el = document.querySelector('[data-tech-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-tech-prev]', '[data-tech-next]')
    }

    applications() {
        document.querySelectorAll('[data-applications-splide]').forEach((el) => {
            const isApp = !!el.closest('.block-app')
            const perView = el.closest('.block-app-v2') ? 2.7 : 2.2
            const splide = new Splide(el, isApp ? {
                type: 'slide',
                fixedWidth: `calc((100% + 2rem) / ${perView} - 2rem)`,
                perMove: 1,
                gap: '2rem',
                trimSpace: true,
                omitEnd: true,
                arrows: false,
                pagination: false,
                breakpoints: {
                    1077: { fixedWidth: 'calc((100% + 2rem) / 1.15 - 2rem)' },
                },
            } : {
                type: 'loop',
                perPage: 3,
                perMove: 1,
                gap: '2rem',
                arrows: false,
                pagination: false,
                breakpoints: {
                    1077: { perPage: 1 },
                },
            }).mount()

            const root = el.closest('section') || el
            const prev = root.querySelector('[data-applications-prev]')
            const next = root.querySelector('[data-applications-next]')

            if (isApp) {
                const sync = () => {
                    const end = splide.Components.Controller.getEnd()
                    if (prev) prev.disabled = splide.index <= 0
                    if (next) next.disabled = splide.index >= end
                }
                splide.on('moved', sync)
                splide.on('resized', sync)
                sync()
            }

            prev?.addEventListener('click', () => splide.go('<'))
            next?.addEventListener('click', () => splide.go('>'))
        })
    }

    caseStudies() {
        document.querySelectorAll('[data-case-studies-splide]').forEach((el) => {
            // ponytail: 2.2 = centrale intera + ~60% per lato; focus center
            new Splide(el, {
                type: 'loop',
                fixedWidth: 'calc((100% - 4rem) / 2.2)',
                perMove: 1,
                gap: '2rem',
                focus: 'center',
                trimSpace: false,
                arrows: false,
                pagination: false,
                breakpoints: {
                    1077: { fixedWidth: 'calc((100% - 2rem) / 1.4)' },
                },
            }).mount()
        })
    }

    partner() {
        const el = document.querySelector('[data-partner-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '1.2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-partner-prev]', '[data-partner-next]')
    }

    product() {
        const el = document.querySelector('[data-product-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-product-prev]', '[data-product-next]')
    }

    related() {
        const el = document.querySelector('[data-related-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-related-prev]', '[data-related-next]')
    }

    domain() {
        const el = document.querySelector('[data-domain-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-domain-prev]', '[data-domain-next]')
    }

    card() {
        const el = document.querySelector('[data-card-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-card-prev]', '[data-card-next]')
    }

    working() {
        const el = document.querySelector('[data-working-splide]')
        if (!el) return
        const splide = new Splide(el, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1077: { perPage: 1 },
            },
        }).mount()

        this.bindArrows(splide, '[data-working-prev]', '[data-working-next]')
    }
}
